import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-links-line text-2xl text-primary-400"></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-50 whitespace-nowrap">磁力链指南</span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专业的磁力链使用指南与资源搜索入口，助你轻松掌握磁力链的全部使用方法。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-foreground-50 font-bold mb-4">内容分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-foreground-50 font-bold mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/tutorials" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                    使用教程
                  </Link>
                </li>
                <li>
                  <Link to="/category/faq-category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                    常见问题
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-foreground-50 font-bold mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="text-sm text-foreground-400">
                  <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                    <i className="ri-mail-line"></i>
                  </span>
                  contact@magnetlink-guide.com
                </li>
                <li className="text-sm text-foreground-400">
                  <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                    <i className="ri-map-pin-line"></i>
                  </span>
                  中国·北京
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} 磁力链指南 — 版权所有
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 no-underline">
                关于我们
              </Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 no-underline">
                联系方式
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}